
import pageNotFound from '../assets/images/pagenotfound.png';
import { Link } from 'react-router-dom';
import { Button } from '../components';
import { useEffect } from 'react';

export const PageNotFound = () => {

  useEffect(()=>{
    document.title =`Page Not Found / Cinemate`
  });
  
  return (
    <main>
      <section className="flex flex-col justify-center px-2">
        <div className="flex flex-col items-center my-4">
          <p className='text-7xl text-gray-700 m-10 dark:text-white'>404, Oops!</p>
          <div className='max-w-lg'>
            <img src={pageNotFound} className='rounded' alt="page not found"/>
          </div>
          <div className="flex justify-center my-4">
            <Link to="/">
              <Button>Back To Cinemate</Button>
            </Link>          
          </div>
        </div>
      </section>
    </main>
  )
}
